<template>
  <div class="notification is-warning">
    You are currently using a trial account which expires on {{accountExpiry}}.
    <p>
      <strong>
        <a @click="upgradeAccount">Upgrade</a>
      </strong> to a full account today!
    </p>
  </div>
</template>

<script>
import date from "date-and-time";
import EventBus from "../event-bus";

export default {
  name: "UserNotifications",
  props: {
    createdOn: String,
    default: "",
    required: true
  },
  computed: {
    accountExpiry: function() {
      let createdDate = date.parse(this.createdOn, "MM/DD/YYYY");
      createdDate = date.addMonths(createdDate, 1);
      return date.format(createdDate, "MMMM D YYYY");
    }
  },
  methods: {
    upgradeAccount: function() {
      EventBus.$emit("displayUpgradeAccount", true);
    }
  }
};
</script>
